var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"row flex-center fit"},[_c('q-btn',_vm._g({attrs:{"size":"sm","color":"tertiary text-right"}},_vm.listeners),[_vm._v(" Create New ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }